import { Inject, Component, OnInit, Input } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { isNullOrUndefined } from 'core-max-lib';
import { Router } from "@angular/router";
import { Server8Service } from "../../../../modules/server8/server8.service";

@Component({
    selector: 'seo-head',
    templateUrl: './seo-head.component.html',
    styleUrls: ['./seo-head.component.scss']
})
export class SeoHeadComponent implements OnInit {
    @Input()
    public searchDescription: string;
    @Input()
    public searchKeywords: string;
    @Input()
    public canonical: string;
    @Input()
    public title: string;

    constructor(
        private metasrv: Meta,
        private titlesrv: Title,
        private router: Router,
        private serverService: Server8Service
    ) {}

    ngOnInit() {
        if (!isNullOrUndefined(this.title)) {
            this.titlesrv.setTitle(this.title);
            if (this.serverService.isCookieEnabled('eve', '8')) {
                this.serverService.server8Mode$.next(true);
            }
            if (this.serverService.isCookieEnabled('eve', '10')) {
                this.serverService.server10Mode$.next(true);
            }
        }

        if (!isNullOrUndefined(this.searchDescription)) {
            this.metasrv.updateTag({ name: 'description', content: this.searchDescription });
        }

        if (!isNullOrUndefined(this.searchKeywords)) {
            this.metasrv.addTag({ name: 'SearchKeywords', content: this.searchKeywords });
        }
        /* this.metasrv.getTags('name="Canonical"').forEach(canonical => this.metasrv.removeTagElement(canonical));

        if (!isNullOrUndefined(this.canonical)) {
            this.metasrv.addTag({ name: 'Canonical', content: this.canonical });
        } else {
            this.metasrv.addTag({
                name: 'Canonical',
                content: this.originUrl + this.router.routerState.snapshot.url.split('?')[0]
            });
        } */
    }
}
